<template>
  <div id="home-header" class="flex flex1 justify-between items-center">
    <img :src="ICON_LOGO" alt="αBIM二维码管理" />
    <div class="header__right flex justify-end items-center">
      <div
        v-if="PROJECT_NAME"
        class="flex justify-center items-center row"
        style="margin-right: 1.5em"
      >
        <span class="header__text">{{ PROJECT_NAME }}</span>
      </div>
      <div class="flex justify-center items-center row">
        <img class="pointer" :src="ICON_ADVICE" alt="意见反馈" />
        <span class="header__text pointer">意见反馈</span>
      </div>
      <el-divider direction="vertical"></el-divider>
      <img :src="ICON_MESSAGES" class="pointer" alt="意见反馈" style="margin-right: 1.5em" />
      <el-popover v-model="visiable" placement="bottom" trigger="click" width="240">
        <div class="myself flex flex1 column">
          <div class="flex flex1 justify-center" style="margin-bottom: 1em; position: relative">
            <div class="self-center">
              <el-avatar :size="80" :src="avatar"></el-avatar>
            </div>
            <div class="mine-out">
              <img class="pointer" :size="40" :src="ICON_OUT" @click="closepop" />
            </div>
          </div>

          <div class="myself__item flex flex1">
            <span class="myself__item-label">用户名</span>
            <span class="myself__item-value">{{ name }}</span>
            <!-- <span class="flex1 self pointer"> 修改 </span> -->
          </div>
          <div class="myself__item flex flex1 items-center">
            <span class="myself__item-label email">邮箱</span>
            <span class="myself__item-value">{{ email }}</span>
          </div>
          <div class="myself__item flex flex1 items-center">
            <span class="myself__item-label">手机号</span>
            <span class="myself__item-value">{{ phone }}</span>
          </div>
          <div class="myself__item flex flex1 justify-center items-center pointer">
            <span class="out" @click="out">退出账号 </span>
            <span class="myself__item-value"></span>
          </div>
        </div>
        <div slot="reference" class="flex row justify-center items-center">
          <el-avatar :size="24" :src="avatar" class="pointer"></el-avatar>
          <span class="header__name pointer">{{ name }}</span>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
// let _this = void 0

export default {
  name: 'HomeHeader',
  components: {},
  filters: {},
  directives: {},
  mixins: [],
  props: {},
  data() {
    return {
      ICON_LOGO: require('@/assets/images/bg/logo.svg'),
      ICON_ADVICE: require('@/assets/images/icon/icon_header_advice.svg'),
      ICON_MESSAGES: require('@/assets/images/icon/icon_header_messages.svg'),
      ICON_AVATAR: require('@/assets/images/icon/icon_header_avatar-default.svg'),
      ICON_OUT: require('@/assets/images/home-info-out.png'),
      avatar: '',
      name: '',
      email: '',
      phone: '',
      visiable: false,
    }
  },
  computed: {
    ...mapState({
      PROJECT_NAME: state => state.PROJECT_NAME,
    }),
  },
  watch: {},
  created() {
    // _this = this
  },
  mounted() {
    const {
      DisplayName: name,
      UserHeadImgUrl: avatar,
      Email: email,
      MobilePhone: phone,
    } = this.getUserInfo()
    this.avatar = avatar ?? this.ICON_AVATAR
    this.email = email ?? ''
    this.phone = phone ?? ''
    this.name = name
  },
  methods: {
    ...mapGetters('user', {
      getUserInfo: 'USER_INFO',
    }),
    out() {
      this.$store.commit('setRouter', { name: 'Login' })
    },
    closepop() {
      this.visiable = false
    },
  },
}
</script>
<style lang="scss" scoped>
.mine-out {
  position: absolute;
  right: 0;
  top: 0;
}
.out {
  opacity: 1;
  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular, sans-serif;
  font-weight: 400;
  text-align: right;
  color: #fa3f19;
}
.self {
  opacity: 1;
  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regula, sans-serif;
  font-weight: 400;
  text-align: right;
  color: #1598d9;
}
.email {
  margin-left: 11px;
}
#home-header {
  height: 60px;
  padding: 0 3em 0 2em;
  opacity: 1;
  background: linear-gradient(79deg, #3d6b99 6%, #163a5b 65%);
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

  .header__text {
    font-size: 13px;
    font-weight: 400;
    margin-left: 5px;
    text-align: left;
    color: #ffffff;
  }

  .header__name {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    margin-left: 5px;
    text-align: left;
    color: #ffffff;
  }

  .el-divider--vertical {
    position: relative;
    display: inline-block;
    width: 1px;
    height: 1em;
    margin: 0 1.5em;
    vertical-align: middle;
  }
}
</style>
<style lang="scss">
.el-avatar {
  background: transparent;
}

.myself {
  .myself__item {
    font-size: 13px;
    margin: 0 0.8em;
    padding: 0.8em 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .myself__item:last-child {
    border-bottom: 0 solid rgba(0, 0, 0, 0.1);
  }

  .myself__item-label {
    color: #888888;
    margin-right: 15px;
  }

  .myself__item-value {
    color: #222222;
  }
}
</style>
